<ejs-dialog target=".dialogs" class="steps-dialog" [visible]='visible' [animationSettings]='dialogService.getAnimationSettings()' [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()' [isModal]="true" [allowDragging]="false" [width]="'60%'" [height]="'60vh'" [zIndex]="999" [showCloseIcon]="false">
  <ng-template #header class="p-1">
    <app-step-header [steps]="stepTitles" [activeStep]="activeStep" (activeStepChange)="handleStepChange($event)"></app-step-header>
  </ng-template>

  <ng-template #content>
    <div class="d-flex h-100">
      <!-- Left Column -->
      <div class="col-md-4 col-12 d-none d-md-flex flex-column left-container h-100 p-3">
        <div class="text-center mb-4 pt-m">
          <app-headline [title]="(homeLinkToEdit ? 'HOMEEDITLINKTITLE' : 'HOMECREATELINKTITLE') | translate" [type]="'h5'"></app-headline>
        </div>
        <app-step-content [steps]="stepTitles" [activeStep]="activeStep" (activeStepChange)="handleStepChange($event)"></app-step-content>
        <div class="save-button-container text-center mt-3 d-none d-md-block">
          <app-form-button [text]="'SAVE' | translate" [disabled]="homeLinkForm.invalid" (click)="save()" [cssClass]="'e-primary w-100'"></app-form-button>
        </div>
      </div>

      <!-- Right Column -->
      <div class="col-md-8 col-12 d-flex flex-column flex-grow-1 right-container h-100 overflow-y-auto p-3">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div class="d-flex align-items-center">
            <app-headline [title]="steps[activeStep].title" [type]="'h5'"></app-headline>
            @if (steps[activeStep]?.optional) {
              <app-headline [title]="'('+('OPTIONALLABEL' | translate) +')'" [type]="'h6'" [class]="'text-success ms-1'"></app-headline>
            }
            <div class="ms-2">
              @if (steps[activeStep]?.help; as help) {
                <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="help" [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
              }
            </div>
          </div>
          <app-form-button [style]="'btn'" (click)="close()" [cssClass]="'btn-close'"></app-form-button>
        </div>

        <!-- Scrollable Form Container -->
        <div class="custom-scrollbar overflow-y-auto">
          <form class="p-1 d-flex flex-column h-100">
            @switch (steps[activeStep]?.id) {
              @case ('details') {
                <app-form-label [label]="'HOMELINKNAME' | translate" [maxChars]="35" [currentChars]="homeLinkForm.controls['name'].value.length"></app-form-label>
                <div class="mb-3">
                  <app-form-input [placeholder]="('HOMELINKNAMEPLACEHOLDER' | translate)" [label]="('HOMELINKNAME' | translate)" [errorText]="('HOMELINKNAMEREQUIRED' | translate)" [fCN]="'name'" [fG]="homeLinkForm" [maxChars]="35"></app-form-input>
                </div>
                <app-form-label [label]="'HOMELINKURL' | translate" [maxChars]="255" [currentChars]="homeLinkForm.controls['url'].value.length"></app-form-label>
                <app-content [fontSize]="'fs-default'" [fontColor]="'text-warning'">{{ 'LINKSECURITYWARNING' | translate }}</app-content>
                <div class="mb-1">
                  <app-form-input [placeholder]="('HOMELINKURLPLACEHOLDER' | translate)" [label]="('HOMELINKURL' | translate)" [errorText]="('HOMELINKURLREQUIRED' | translate)" [fCN]="'url'" [fG]="homeLinkForm" [maxChars]="255"></app-form-input>
                </div>
              }
              @case ('properties') {
                <!-- <app-form-label [label]="'HOMELINKTYPE' | translate"></app-form-label>
                <div class="d-flex align-items-center mb-4">
                  <div class="col-4 col-md-3 me-2">
                    <app-form-radio [fG]="homeLinkForm" [fCN]="'type'" [value]="'internal'" [placeholder]="'HOMELINKTYPEINTERNAL' | translate"></app-form-radio>
                  </div>
                  <div class="col-4 col-md-3 me-2">
                    <app-form-radio [fG]="homeLinkForm" [fCN]="'type'" [value]="'external'" [placeholder]="'HOMELINKTYPEEXTERNAL' | translate"></app-form-radio>
                  </div>
                </div> -->
                <app-form-label [label]="'HOMELINKPLATFORM' | translate"></app-form-label>
                <div class="d-flex align-items-center mb-4">
                  <div class="col-4 col-md-3 me-2">
                    <app-form-radio [fG]="homeLinkForm" [fCN]="'platform'" [value]="'both'" [placeholder]="'HOMELINKPLATFORMBOTH' | translate"></app-form-radio>
                  </div>
                  <div class="col-4 col-md-3 me-2">
                    <app-form-radio [fG]="homeLinkForm" [fCN]="'platform'" [value]="'mobile'" [placeholder]="'HOMELINKPLATFORMMOBILE' | translate"></app-form-radio>
                  </div>
                  <div class="col-4 col-md-3 me-2">
                    <app-form-radio [fG]="homeLinkForm" [fCN]="'platform'" [value]="'desktop'" [placeholder]="'HOMELINKPLATFORMDESKTOP' | translate"></app-form-radio>
                  </div>
                </div>
                <div class="d-flex align-items-center gap-1">
                  <app-form-label [label]="('HOMELINKAVAILABLE' | translate)"></app-form-label>
                  <app-form-label [type]="'content'" [class]="'text-secondary fs-small fw-bold'" [label]="'(' + ('OPTIONALLABEL' | translate) +')'"></app-form-label>
                </div>
                <div class="row g-2 justify-content-start">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-3 col-sm-3 col-md-3 col-lg-2 d-flex align-items-center">
                        <span class="text-muted fs-default">
                          <app-form-label [type]="'content'" [label]="'HOMELINKDATETIMESTART' | translate"></app-form-label>
                        </span>
                      </div>
                      <div class="col-9 col-sm-9 col-md-6 col-lg-6">
                        <app-form-date-time [fG]="homeLinkForm" [fCN]="'visible_from'" [placeholder]="'SELECTDATEPLACEHOLDER' | translate"></app-form-date-time>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="row">
                      <div class="col-3 col-sm-3 col-md-3 col-lg-2 d-flex align-items-center">
                        <span class="text-muted fs-default">
                          <app-form-label [type]="'content'" [label]="'HOMELINKDATETIMEEND' | translate"></app-form-label>
                        </span>
                      </div>
                      <div class="col-9 col-sm-9 col-md-6 col-lg-6">
                        <app-form-date-time [fG]="homeLinkForm" [fCN]="'visible_to'" [placeholder]="'SELECTDATEPLACEHOLDER' | translate" [min]="visibleToMinDate"></app-form-date-time>
                      </div>
                    </div>
                  </div>
                </div>
              }
              @case ('sharing') {
                <app-form-user-group-mail 
                  [(user)]="participantsUserIDs" 
                  [(groups)]="participantsGroupIDs"
                  [can]="''"
                  >
                </app-form-user-group-mail>
              }
            }
          </form>
        </div>

        <div class="d-flex justify-content-between mt-3 d-none d-md-flex">
          @if (activeStep > 0) {
            <app-form-button [text]="'PREV' | translate" (click)="activeStep = activeStep - 1" [cssClass]="'e-outline w-20'"></app-form-button>
          }
          @if (activeStep < steps.length - 1) {
            <app-form-button [text]="'NEXT' | translate" (click)="handleStepChange()" [cssClass]="'e-secondary ms-auto w-20'"></app-form-button>
          }
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #footerTemplate>
    <div class="d-md-none d-flex gap-2 p-2">
      <div class="flex-shrink-0">
        @if (activeStep > 0) {
          <app-form-button [text]="'PREV' | translate" (click)="activeStep = activeStep - 1" [cssClass]="'e-outline w-100 mx-1'"></app-form-button>
        }@else {
          <!-- Dummy button to keep the space for the flex container -->       
          <app-form-button [text]="'PREV' | translate" [cssClass]="'e-outline invisible w-100 mx-1'"></app-form-button>
        }
      </div>
      <div class="flex-grow-1 d-flex justify-content-center">
        <app-form-button [text]="'SAVE' | translate" [disabled]="homeLinkForm.invalid" (click)="save()" [cssClass]="'e-primary w-90'"></app-form-button>
      </div>
      <div class="flex-shrink-0">
        @if (activeStep < steps.length - 1) {
          <app-form-button [text]="'NEXT' | translate" (click)="handleStepChange()" [cssClass]="'e-secondary w-100 mx-1'"></app-form-button>
        }

        <!-- Dummy button to keep the space for the flex container -->
        @if (activeStep === steps.length - 1) {
          <app-form-button [text]="'NEXT' | translate" (click)="handleStepChange()" [cssClass]="'e-secondary invisible w-100 mx-1'"></app-form-button>
        }
      </div>
    </div>
  </ng-template>
</ejs-dialog>
